module.exports = __webpack_public_path__ + "img/img_loading.b215cd11.png";